import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TreeNode } from '../../model/tree-node';
import { TreeItemComponent } from '../tree-item/tree-item.component';

@Component({
  selector: 'app-tree',
  templateUrl: './tree.component.html',
  styleUrls: [ './tree.component.scss' ],
  imports: [ TreeItemComponent ]
})
export class TreeComponent {
  @Input() tree: TreeNode[];
  @Input() showCount = true;
  @Input() selectedNodes: string[];
  @Output() selectNode = new EventEmitter<TreeNode>();
  @Output() deselectNode = new EventEmitter<TreeNode>();
  collapsedNodes = new Map<string, boolean>();
}
